/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslation } from '@axo/shared/i18n';
import { Card } from '@axo/ui-core/components/Card';
import { Icon } from '@axo/ui-core/components/Icon';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Navigation } from '../../../../../../components';
import { ESkatLoggedIn } from '../../../../ESkat';
import styles from './ESkatGroup.module.scss';

export const ESkatLogged = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <Stack as="span" align="center" className={styles.successColor}>
        <Icon name="check-circle" size="l" />
      </Stack>

      <Stack>
        <ESkatLoggedIn />

        <Navigation.Continue>{t('next')}</Navigation.Continue>
      </Stack>
    </Card>
  );
};
